// extracted by mini-css-extract-plugin
export var container = "_59-1";
export var editor = "_59-2";
export var resizable = "_59-3";
export var wrapper = "_59-0";